import React from 'react';

const IllustrationComponent = ({ name, height = '136px' }: { name: string; height?: string }): JSX.Element => {
  const image = window.Jbhifi?.Images?.[name];

  return image?.x1 ? (
    <div className="illustration-container" style={{ height }}>
      <img className="illustration" src={image.x1} srcSet={`${image.x1} 1x, ${image.x2} 2x, ${image.x3} 3x`} alt="" />
    </div>
  ) : null;
};

export default IllustrationComponent;
